export const SHOW_MESSAGE = 'HIERARCHY_INFO/SHOW_MESSAGE';
export const CLEAR_MESSAGE = 'HIERARCHY_INFO/CLEAR_MESSAGE';
export const INIT_MESSAGE_BOX = 'HIERARCHY_INFO/INIT_MESSAGE_BOX';
export const CLEAR_MESSAGE_BOX = 'HIERARCHY_INFO/CLEAR_MESSAGE_BOX';
export const CLEAR_ALL_MESSAGE_BOX = 'HIERARCHY_INFO/CLEAR_ALL_MESSAGE_BOX';
